import React from "react";

import { cn } from "@perceptron/utils/cn";

import { Icon } from "./icon";

interface AnnotationBadgeProps {
  count: number;
  className?: string;
  position?: "bottom-left" | "bottom-right" | "top-left" | "top-right";
}

const positionClasses = {
  "bottom-left": "bottom-1 left-1",
  "bottom-right": "bottom-1 right-1",
  "top-left": "top-1 left-1",
  "top-right": "top-1 right-1",
};

export const AnnotationBadge: React.FC<AnnotationBadgeProps> = ({ count, className, position = "bottom-left" }) => {
  if (count <= 0) return null;

  return (
    <div
      className={cn(
        "bg-badge absolute z-40 flex items-center gap-1 rounded-sm px-1.5 py-1 text-xs font-medium text-white shadow-md backdrop-blur-[2px]",
        positionClasses[position],
        className,
      )}
    >
      <Icon className="size-4" name="box-icon" />
      <span>{count}</span>
    </div>
  );
};
